import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=158c7e34&scoped=true&"
import script from "./Goods.vue?vue&type=script&lang=js&"
export * from "./Goods.vue?vue&type=script&lang=js&"
import style0 from "./Goods.vue?vue&type=style&index=0&id=158c7e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158c7e34",
  null
  
)

export default component.exports